import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { DataService } from '../shared/dataService';
import { catchError, tap, map } from "rxjs/operators";
import { Observable, of } from 'rxjs';
@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public dataService: DataService, public router: Router) {}
  //canActivate(): boolean {
  //    if (!this.dataService.isAuthenticated()) {
  //        this.dataService.refreshTokens().pipe(
  //            tap(
  //                () => {
  //                    if (!this.dataService.isAuthenticated()) {
  //                        this.router.navigate(['login']);
  //                        return false;
  //                    }
  //                }
  //            )
  //        )
  //  }
  //  return true;
  //}
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        //const expectedRole = route.data.expectedRole ? route.data.expectedRole : null;
        //const tokenPayload = this.dataService.();
        return this.dataService.isAuthenticated()
            .pipe(
                map(isAuth => {
                    if (!isAuth) {
                        this.router.navigate(['login']);
                        return false;
                    } else {
                        return true;
                    }
                }),
                catchError((error, caught) => {
                    return of(false);
                })
            );
    }
}